/* eslint-disable no-unused-vars */
import { Table } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import React from 'react'
import { DAYS_OF_WEEK_SHORTEN } from '../../../constants'
import {
  EventsByHour,
  ICell,
  IEvent,
  INorm,
  ITableColumn
} from '../../../types'
import styles from '../SAPPCalendar.module.css'
import { checkIsAllday, hoursOfDayKeys } from '../../../utils'
import LMSWeeklyCell from './LMSWeeklyCell'

dayjs.extend(isBetween)

interface IWeeklyCalendarProps {
  startDate: Dayjs
  endDate: Dayjs
  events: IEvent[]
  norms: INorm[]
  onOpenDetail?: (date: Date, events: IEvent[]) => void
  onOpenCreate?: (date: Date) => void
  onEventDetail?: (event: IEvent) => void
  loading?: boolean
  type?: 'OPS' | 'LMS'
}

const LMSWeeklyCalendar = ({
  startDate,
  events,
  onOpenDetail,
  onOpenCreate,
  onEventDetail,
  loading
}: IWeeklyCalendarProps) => {
  const getEventsOfHour = (events: IEvent[], targetHour: Dayjs) =>
    hoursOfDayKeys.reduce((acc: any, hour) => {
      acc[hour] = {
        events: events.filter((event) => {
          return (
            dayjs(event.startDate).isSame(
              dayjs(`${targetHour.format('YYYY-MM-DD')}T${hour}:00`),
              'hour'
            ) && !checkIsAllday(dayjs(event.startDate), dayjs(event.endDate))
          )
        }),
        date: dayjs(`${targetHour.format('YYYY-MM-DD')}T${hour}`)
      }
      return acc
    }, {} as EventsByHour)

  const getTableColumns = () => {
    const hourColumn: ITableColumn = {
      title: <div className={styles['weekly-calendar__title']} />,
      dataIndex: 'hour',
      key: 'hour',
      width: 1,
      render: (value: string) => <div>{value}</div>
    }

    const hours = Array.from({ length: 17 }, (_, i) => 7 + i)
    const timeColums: ITableColumn[] = hours.map((time, index) => ({
      title: (
        <div className={styles['weekly-calendar__title']}>
          {time % 2 !== 0 ? (
            <div style={{ textAlign: 'start' }}>
              {time < 10 ? '0' + time + ':00' : time + ':00'}
            </div>
          ) : (
            <div style={{ minWidth: '35px' }} />
          )}
        </div>
      ),
      dataIndex: `${time < 10 ? '0' + time + ':00' : time + ':00'}`,
      key: `${time < 10 ? '0' + time + ':00' : time + ':00'}`,
      render: (value: ICell) => {
        return (
          <LMSWeeklyCell
            key={index}
            events={value?.events}
            date={value?.date}
            onOpenDetail={onOpenDetail}
            onOpenCreate={onOpenCreate}
            onEventDetail={onEventDetail}
          />
        )
      }
    }))

    return [hourColumn, ...timeColums]
  }

  const getTableData = () => {
    const data = []
    for (let i = 0; i < 7; i++) {
      const targetHour = dayjs(startDate).add(i + 1, 'day')
      data.push({
        id: i,
        hour: (
          <div>
            <div className={styles['lms-calendar__tablet']}>
              {Object.values(DAYS_OF_WEEK_SHORTEN)[i]}
            </div>
            <div className={styles['lms-calendar__tablet']}>
              {dayjs(startDate).add(i, 'day').format('DD')}
            </div>
          </div>
        ),
        ...getEventsOfHour(events, targetHour)
      })
    }
    return data
  }

  return (
    <Table
      rowKey={(record) => record.id}
      columns={getTableColumns()}
      dataSource={getTableData()}
      pagination={false}
      rowHoverable={false}
      className={styles['weekly-calendar']}
      loading={loading}
    />
  )
}

export default LMSWeeklyCalendar
